import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function ClientProductsModal({
  show,
  editId,
  productId,
  setProductId,

  allProducts,

  price,
  setPrice,

  comment,
  setComment,

  priceTiers,
  setPriceTiers,

  save,
  closeModal,
}) {
  const { t } = useTranslation("ClientsPage");




  if (!show) return null;



  const addTier = () => {
    setPriceTiers([
      ...priceTiers,
      {
        min: "",
        max: "",
        price: "",
      },
    ]);
  };



  const removeTier = (index) => {
    setPriceTiers(
      priceTiers.filter((_, i) => i !== index)
    );
  };



  const updateTier = (index, field, value) => {
    const copy = [...priceTiers];

    copy[index][field] = value;

    setPriceTiers(copy);
  };



  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">


      <div className="bg-white p-4 w-96 space-y-3 rounded max-h-[90vh] overflow-y-auto">


        <select
          value={productId}
          onChange={(e) => setProductId(e.target.value)}
          className="border w-full p-2"
        >

          <option value="">
            {t("select_product")}
          </option>


          {allProducts.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name_en}
            </option>
          ))}

        </select>




        <input
          placeholder={t("price")}
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          className="border w-full p-2"
        />




        <input
          placeholder={t("comment")}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="border w-full p-2"
        />





        <div className="border-t pt-3">


          <div className="flex justify-between items-center mb-3">

            <span className="font-semibold">
              Цена относительно количества
            </span>


            <button
              onClick={addTier}
              className="bg-blue-500 text-white px-3 py-1 rounded text-sm"
            >
              + Добавить шкалу цен
            </button>

          </div>





          <div className="space-y-3">


            {priceTiers.map((tier, index) => (

              <div
                key={index}
                className="border rounded p-3 bg-gray-50"
              >


                <div className="flex justify-between mb-2">

                  <span className="font-medium">
                    Диапазон #{index + 1}
                  </span>


                  <button
                    onClick={() => removeTier(index)}
                    className="text-red-500 text-sm"
                  >
                    удалить
                  </button>

                </div>




                <input
                  placeholder="Минимальное количество"
                  value={tier.min}
                  onChange={(e) =>
                    updateTier(
                      index,
                      "min",
                      e.target.value
                    )
                  }
                  className="border w-full p-2 mb-2"
                />




                <input
                  placeholder="Максимальное количество"
                  value={tier.max}
                  onChange={(e) =>
                    updateTier(
                      index,
                      "max",
                      e.target.value
                    )
                  }
                  className="border w-full p-2 mb-2"
                />




                <input
                  placeholder="Цена для этого диапазона"
                  value={tier.price}
                  onChange={(e) =>
                    updateTier(
                      index,
                      "price",
                      e.target.value
                    )
                  }
                  className="border w-full p-2"
                />



              </div>

            ))}


          </div>



        </div>





        <div className="flex justify-between pt-3">


          <button
            onClick={save}
            className="bg-green-600 text-white px-3 py-1 rounded"
          >
            {editId ? t("save") : t("add")}
          </button>



          <button
            onClick={closeModal}
            className="bg-gray-400 text-white px-3 py-1 rounded"
          >
            {t("cancel")}
          </button>



        </div>



      </div>


    </div>
  );
}